import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const chaunceyTrades: SeasonTrades[] = [
  {
    season: "2012/13",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Nikola Vucevic",
        gotInReturn: "Kevin Martin",
      },
      {
        otherTeam: manager.dom,
        sentAway: "Ty Lawson",
        gotInReturn: "Steve Nash",
      },
      {
        otherTeam: manager.dom,
        sentAway: "Klay Thompson",
        gotInReturn: "Zach Randolph",
        amongWorstTrades: true
      },
      {
        otherTeam: manager.itay,
        sentAway: "Monta Ellis and Anderson Varejao",
        gotInReturn: "Stephen Curry and Devin Harris",
        amongBestTrades: true
      },
      {
        otherTeam: manager.ariel,
        sentAway: "Kobe Bryant",
        gotInReturn: "Serge Ibaka",
        amongBestTrades: true
      },
      {
        otherTeam: manager.jDog,
        sentAway: "Tristan Thompson",
        gotInReturn: "Roy Hibbert",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Zach Randolph and Eric Gordon",
        gotInReturn: "David West and Ricky Rubio",
      },
    ],
  },
  {
    season: "2013/14",
    allTrades: [
      {
        otherTeam: manager.dom,
        sentAway: "Serge Ibaka and Carlos Boozer",
        gotInReturn: "Ty Lawson, Nikola Pekovic and Spencer Hawes",
      },
      {
        otherTeam: manager.dom,
        sentAway: "Andrew Bogut and Roy Hibbert",
        gotInReturn: "Kevin Martin",
      },
      {
        otherTeam: manager.nissim,
        sentAway: "Ricky Rubio",
        gotInReturn: "Tim Duncan",
        amongBestTrades: true
      },
      {
        otherTeam: manager.itay,
        sentAway: "Kobe Bryant",
        gotInReturn: "Carlos Boozer",
      },
      {
        otherTeam: manager.itay,
        sentAway: "Kyle Korver",
        gotInReturn: "Andrew Bogut",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Marc Gasol and Chandler Parsons",
        gotInReturn: "Blake Griffin",
        amongBestTrades: true
      },
      {
        otherTeam: manager.mati,
        sentAway: "Nikola Pekovic",
        gotInReturn: "Chandler Parsons",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Ty Lawson and David Lee",
        gotInReturn: "Marc Gasol and Kyle Lowry",
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Marc Gasol and Chandler Parsons",
        gotInReturn: "DeMar DeRozan",
      },
      {
        otherTeam: manager.ariel,
        sentAway: "Al Jefferson",
        gotInReturn: "Bradley Beal",
      },
      {
        otherTeam: manager.ariel,
        sentAway: "Zach Randolph and Larry Sanders",
        gotInReturn: "Roy Hibbert and Courtney Lee",
      },
      {
        otherTeam: manager.ariel,
        sentAway: "Tim Duncan",
        gotInReturn: "Zach Randolph",
      },
      {
        otherTeam: manager.idan,
        sentAway:
          "Jeff Teague, Derrick Favors, Ryan Anderson, John Henson and Jared Sullinger",
        gotInReturn: "Deron Williams, Al Jefferson, David Lee and Jeremy Lamb",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Deron Williams",
        gotInReturn: "Chandler Parsons",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Rajon Rondo and Spencer Hawes",
        gotInReturn: "Zach Randolph and Andre Iguodala",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Anderson Varejao",
        gotInReturn: "Kyle Korver",
      },
    ],
  },
  {
    season: "2014/15",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "DeAndre Jordan",
        gotInReturn: "Tyson Chandler and Gorgui Dieng",
        amongBestTrades: true
      },
      {
        otherTeam: manager.nissim,
        sentAway: "Gorgui Dieng",
        gotInReturn: "DeMar DeRozan",
      },
      {
        otherTeam: manager.itay,
        sentAway: "Kevin Martin",
        gotInReturn: "Andrew Bogut",
      },
      {
        otherTeam: manager.itay,
        sentAway: "Andrew Bogut, Ty Lawson and KJ McDaniels",
        gotInReturn: "Serge Ibaka",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Monta Ellis and Tristan Thompson",
        gotInReturn: "Kenneth Faried and Robert Covington",
      },
      {
        otherTeam: manager.idan,
        sentAway: "Kyle Lowry and Robert Covington",
        gotInReturn: "DeAndre Jordan",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Blake Griffin",
        gotInReturn: "Al Jefferson"
      },
    ],
  },
  {
    season: "2015/16",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "Dirk Nowitzki",
        gotInReturn: "Kenneth Faried",
      },
      {
        otherTeam: manager.idan,
        sentAway: "Mike Conley",
        gotInReturn: "Ricky Rubio",
      },
      {
        otherTeam: manager.idan,
        sentAway: "Marcin Gortat and Kenneth Faried",
        gotInReturn: "Al Horford",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Garry Harris and higher pick in Veterans Draft",
        gotInReturn: "Alex Len and lower pick in Veterans Draft",
      },
    ],
  },
];
